function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#2CA72A"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.5499 13.4397C29.8311 13.721 29.9891 14.1024 29.9891 14.5002C29.9891 14.8979 29.8311 15.2794 29.5499 15.5607L18.3069 26.8037C18.1584 26.9523 17.982 27.0702 17.7878 27.1506C17.5937 27.231 17.3856 27.2724 17.1754 27.2724C16.9653 27.2724 16.7572 27.231 16.5631 27.1506C16.3689 27.0702 16.1925 26.9523 16.0439 26.8037L10.4579 21.2187C10.3147 21.0803 10.2004 20.9148 10.1218 20.7318C10.0432 20.5488 10.0018 20.352 10.0001 20.1528C9.99833 19.9536 10.0363 19.7561 10.1117 19.5717C10.1871 19.3874 10.2985 19.2199 10.4393 19.0791C10.5802 18.9382 10.7477 18.8269 10.932 18.7514C11.1163 18.676 11.3139 18.6381 11.513 18.6398C11.7122 18.6415 11.909 18.6829 12.092 18.7615C12.275 18.8401 12.4406 18.9544 12.5789 19.0977L17.1749 23.6937L27.4279 13.4397C27.5672 13.3003 27.7326 13.1897 27.9147 13.1143C28.0967 13.0388 28.2919 13 28.4889 13C28.686 13 28.8811 13.0388 29.0632 13.1143C29.2452 13.1897 29.4106 13.3003 29.5499 13.4397Z",
  fill: "white"
});
function SvgSuccesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccesIcon);
export default __webpack_public_path__ + "static/media/succes_icon.4e3c2fed368091588c4a5e92d762a89f.svg";
export { ForwardRef as ReactComponent };